import { Link, useParams } from "react-router-dom";
import SiteShell from "@/components/feature/SiteShell";
import Breadcrumb from "@/components/base/Breadcrumb";
import { getCategoryConfig } from "@/hooks/useCatalog";
import FilterWorkspace from "./components/FilterWorkspace";

export default function ListPage() {
  const { type } = useParams();
  const config = getCategoryConfig(type);

  if (!config) {
    return (
      <SiteShell
        breadcrumb="/category"
        pageTitle="分类不存在 - 长日光阴"
        pageDescription="您访问的影视列表页面不存在，请返回首页浏览电影与电视剧内容。"
        pageKeywords="长日光阴,影视列表"
      >
        <div className="flex min-h-[70vh] flex-col items-center justify-center px-4 pt-24 text-center">
          <i className="ri-error-warning-line text-4xl text-foreground-400" aria-hidden="true"></i>
          <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950">分类不存在</h1>
          <Link
            to="/"
            className="mt-6 rounded-md bg-primary-800 px-5 py-2.5 text-sm text-background-50 whitespace-nowrap cursor-pointer hover:bg-primary-700"
          >
            返回首页
          </Link>
        </div>
      </SiteShell>
    );
  }

  return (
    <SiteShell
      breadcrumb={`/category/${config.type}/list`}
      pageTitle={`全部${config.name}列表 - 长日光阴影视资源库`}
      pageDescription={`长日光阴${config.name}列表页，支持按地区、年份、类型多条件筛选，并提供热门、最新、评分三种排序方式，帮助你快速找到想看的${config.name}作品。`}
      pageKeywords={`长日光阴,${config.name}列表,${config.name}筛选,影视资源库`}
    >
      <div className="pt-16 md:pt-[72px]">
        <section className="w-full border-b border-background-200 bg-background-100">
          <div className="mx-auto max-w-[1440px] px-4 py-8 md:px-8 md:py-10">
            <Breadcrumb
              items={[
                { label: "首页", to: "/" },
                { label: config.name, to: `/category/${config.type}` },
                { label: "全部作品" },
              ]}
            />
            <div className="mt-5 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
              <div>
                <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                  全部{config.name}
                </h1>
                <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
                  在{config.name}资源库里组合地区、年份与类型条件，快速收窄范围。当前条件与排序都会即时反映在下方列表中。
                </p>
              </div>
              <Link
                to={`/category/${config.type}`}
                className="inline-flex items-center gap-1.5 self-start rounded-md border border-background-300 bg-background-50 px-4 py-2 text-xs text-foreground-700 whitespace-nowrap transition-colors cursor-pointer hover:border-primary-300 hover:text-primary-700 md:self-auto"
              >
                <i className="ri-arrow-left-line" aria-hidden="true"></i>
                返回{config.name}分类
              </Link>
            </div>
          </div>
        </section>

        <FilterWorkspace />
      </div>
    </SiteShell>
  );
}